/**
 * @license lucide-vue-next v0.536.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const Minus = createLucideIcon("minus", [["path", { d: "M5 12h14", key: "1ays0h" }]]);

export { Minus as default };
//# sourceMappingURL=minus.js.map
